// extracted by mini-css-extract-plugin
export default {"footerContainer":"Footer_footerContainer__cqEAW","socialsContainer":"Footer_socialsContainer__b68Z9","footerH1":"Footer_footerH1__FFI1T"};